// extracted by mini-css-extract-plugin
export default {"tag":"fXWSHD8","tag--default":"BH0AHn1","tag--disabled":"uDqGejn","tag--lime":"QvmKG0Q","tag__button":"HbIpDk9","tag__icon":"WgUAl9p"};